import React from 'react';

import useHpEventCta from '../../../hooks/useHpEventCta';
import { HpEventCtaVariants } from '../constants';

import styles from '../findAccommodations.scss';

const ControlVariant = ({ surface, event }) => {
    const {
        eventCityName,
        findAccommodationsTitle,
        handleCtaClick,
        handleLearnMoreClick,
    } = useHpEventCta({ surface, event, variant: HpEventCtaVariants.CONTROL });

    return (
        <div
            className={styles.hpEventCtaContainer}
        >
            <p
                className={styles.title}
                data-testid="event-profile.find-accommodations.control.title"
            >
                {eventCityName ? `Save on your stay in ${eventCityName}` : 'Save on your stay'}
            </p>
            <p
                className={styles.subtitle}
                data-testid="event-profile.find-accommodations.control.subtitle"
            >
                {findAccommodationsTitle}
            </p>
            <ul
                className={styles.list}
                data-testid="event-profile.find-accommodations.control.benefits"
            >
                <li>Over $250 of value in travel benefits</li>
                <li>Up to 60% off on 1.4 million hotels globally</li>
            </ul>
            <button
                type="button"
                className={`btn btn-primary btn-small text-uppercase mt16 mb16 ${styles.button}`}
                onClick={handleCtaClick}
                data-testid="event-profile.find-accommodations.control.unlock-power-rates-btn"
            >
                Unlock Power Rates
            </button>
            <div
                className={styles.learnMore}
                onClick={handleLearnMoreClick}
                data-testid="find-accommodations.control.learn-more-div"
            >
                <span
                    className={styles.underline}
                    data-testid="event-profile.find-accommodations.control.learn-more-label"
                >
                    Learn more
                </span>
                {' about '}
                <span data-testid="event-profile.find-accommodations.control.learn-more-target">
                    Global Privileges
                </span>
            </div>
        </div>
    );
};

export default ControlVariant;
